import { defineVideoTemplate } from "@assets/templates/builders";
import { BASE_ASSETS } from "@assets/templates/constants";

export const factoryFloorVideoExample = defineVideoTemplate({
  slug: "factory-floor-video-example",
  title: "Manufacturing",
  description: "Action counting",
  subdescription: "Count crates placed and clip the moments they land",
  poster: BASE_ASSETS.factoryFloorVideoPoster,
  video: BASE_ASSETS.factoryFloorVideo,
  prompt: "how many crates did he pick up and place. Use the <clip> tag to show me when it was placed.",
  annotationFormat: "clip",
  enableThinking: true,
});
